const ConfigHelper = {
    GraphQlUrl: "https://dev.familytc.com/graphql",
    Auth0_ClientId: "F1aN0P253OYhj004gc93v9uD5DGCQBtU",
    //Auth0_RoleId: "rol_fN6dHIh21S99Fbid",
    Auth0_Audience: "https://dev-b8dnjx5d.us.auth0.com/api/v2/",
    Auth0_domain: "dev-b8dnjx5d.us.auth0.com",
    ReactGA: "G-RTYR7G1DV3",
    email: 'boris.stambler@yahoo.com',
    subEmail: ['boris.stambler@yahoo.com'],
    base_url: 'https://dev-b8dnjx5d.us.auth0.com',
    base_api: 'https://dev.familytc.com/api',
    url: 'https://dev.familytc.com',
    title: "FamilyTC"
};

export default ConfigHelper;